<template>
  <div class="code-details">
    <div v-if="codeType === 'setup_key'" class="code-details__key">
      <div class="code-details__header">
        <div class="code-details__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21 2L19 4M19 4L22 7L18.5 10.5L15.5 7.5M19 4L15.5 7.5M11.39 11.61C12.3619 12.5743 12.9011 13.8914 12.8869 15.26C12.8728 16.6287 12.3063 17.9343 11.3142 18.8778C10.3221 19.8213 8.98838 20.3228 7.62073 20.2692C6.25307 20.2156 4.95883 19.6115 4.02299 18.5833C3.08716 17.555 2.58652 16.1892 2.63218 14.7843C2.67784 13.3794 3.26626 12.0498 4.27316 11.0759C5.28007 10.1021 6.62789 9.5581 8.03216 9.57187C9.43644 9.58565 10.7735 10.1559 11.76 11.18L11.39 11.61ZM11.39 11.61L15.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3 class="code-details__title">Your Setup Key</h3>
        <p class="code-details__desc">Enter this code into your authenticator app</p>
      </div>
      <div class="code-details__code-box">
        <textarea
          class="code-details__textarea"
          type="text"
          readonly
          :value="code"
          @focus="$event.target.select()"
          ref="code"
        />
        <button
          type="button"
          class="code-details__copy-btn"
          @click="copyText()"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          Copy Key
        </button>
      </div>
    </div>
    
    <div v-if="codeType === 'qr_code'" class="code-details__qr">
      <div class="code-details__header">
        <div class="code-details__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="14" y="14" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
            <rect x="18" y="14" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
            <rect x="14" y="18" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
            <rect x="18" y="18" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </div>
        <h3 class="code-details__title">Scan QR Code</h3>
        <p class="code-details__desc">Scan the QR code with your authenticator app</p>
      </div>
      <div class="code-details__qr-wrapper">
        <img :src="code" class="code-details__qr-image" alt="QR Code" />
      </div>
      <Btn class="code-details__btn" title="I have Scanned" @click="$emit('continue')" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Btn from "@/components/general/BtnComponent.vue";

export default {
  name: "CodeDetails",

  emits: ["continue"],

  components: {
    Btn,
  },

  computed: {
    ...mapState({
      code: (state) => state.organisationModule.code,
      codeType: (state) => state.organisationModule.codeType,
    }),
  },

  methods: {
    ...mapActions(["showToast"]),

    copyText() {
      this.$refs.code.focus();
      document.execCommand("copy");
      this.showToast({
        description: `Key copied`,
        display: true,
        type: "success",
      });
      this.$emit("continue");
    },
  },
};
</script>

<style lang="scss" scoped>
.code-details {
  padding: 0 24px;

  &__header {
    text-align: center;
    margin-bottom: 32px;
  }

  &__icon {
    width: 56px;
    height: 56px;
    background: #F1F5F9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: #4D84FF;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 8px 0;
  }

  &__desc {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
  }

  &__code-box {
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__textarea {
    width: 100%;
    background: transparent;
    border: none;
    font-family: 'DM Sans', monospace;
    font-size: 13px;
    font-weight: 500;
    color: #0F172A;
    resize: none;
    height: 60px;
    word-break: break-all;
    outline: none;

    &:focus {
      outline: none;
    }
  }

  &__copy-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    background: #4D84FF;
    color: white;
    border: none;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #3D6FE6;
    }
  }

  &__qr {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__qr-wrapper {
    background: white;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 32px;
  }

  &__qr-image {
    width: 180px;
    height: 180px;
    display: block;
  }

  &__btn {
    width: 100%;
    max-width: 280px;
  }
}
</style>
